import { jsxs as l, jsx as C } from "react/jsx-runtime";
const e = ({
  width: r,
  height: t,
  className: i
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: i,
    fill: "none",
    height: t,
    viewBox: "0 0 14 14",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_15632_14487)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M0.5 6.98674C0.5 5.23151 0.5 3.47629 0.5 1.72106C0.5 0.68501 1.18186 0 2.21342 0C5.37598 0 8.53898 0 11.7015 0C12.7367 0 13.4199 0.681863 13.4199 1.71567C13.4199 4.18872 13.4176 6.66132 13.4221 9.13436C13.423 9.69891 13.2149 10.1515 12.7879 10.5192C11.6364 11.5108 10.4875 12.505 9.3458 13.5074C8.96374 13.8427 8.53808 14.0022 8.02882 14C6.09425 13.991 4.15968 13.9969 2.22511 13.9964C1.17962 13.9964 0.5 13.3159 0.5 12.269C0.5 10.5084 0.5 8.74736 0.5 6.98674ZM7.49843 12.9199V12.7181C7.49843 11.9162 7.49798 11.1143 7.49843 10.3125C7.49933 9.30157 8.18748 8.61431 9.19926 8.61341C10.1863 8.61251 11.1729 8.61341 12.16 8.61341H12.3434V8.42059C12.3434 6.18891 12.3434 3.95723 12.3434 1.72556C12.3434 1.27563 12.1465 1.07696 11.7006 1.07696C8.53808 1.07696 5.37553 1.07696 2.21297 1.07696C1.77698 1.07696 1.57696 1.27788 1.57651 1.71477C1.57651 5.23601 1.57651 8.7577 1.57651 12.2789C1.57651 12.7172 1.77653 12.9199 2.20983 12.9199C3.90887 12.9199 5.60791 12.9199 7.30695 12.9199H7.49798H7.49843ZM12.0966 9.69082C11.0565 9.69082 10.0704 9.68633 9.0842 9.69352C8.78754 9.69576 8.57673 9.93893 8.57583 10.2527C8.57359 11.0429 8.57493 11.8335 8.57583 12.6237C8.57583 12.6529 8.58617 12.6821 8.59471 12.7289C9.76022 11.718 10.91 10.7201 12.0971 9.69037L12.0966 9.69082Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M6.96003 2.69193C8.0253 2.69193 9.09057 2.69058 10.1558 2.69283C10.5721 2.69373 10.844 3.07669 10.684 3.43852C10.5833 3.66685 10.3968 3.76979 10.1469 3.76934C9.18271 3.76754 8.21813 3.76844 7.25399 3.76844C6.09343 3.76844 4.93287 3.76979 3.77231 3.76754C3.35159 3.76664 3.0828 3.39582 3.23068 3.02814C3.31788 2.81194 3.51116 2.69193 3.78085 2.69193C4.84027 2.69103 5.90015 2.69193 6.95958 2.69193H6.96003Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M6.95807 6.32556C5.8928 6.32556 4.82753 6.32736 3.76226 6.32466C3.35188 6.32376 3.08444 5.95518 3.22962 5.5929C3.31457 5.3812 3.47818 5.26478 3.70652 5.2513C3.84047 5.24321 3.97576 5.24905 4.11016 5.24905C6.10046 5.24905 8.09076 5.24905 10.0811 5.24905C10.1539 5.24905 10.228 5.24635 10.2986 5.26119C10.5625 5.31557 10.7459 5.56144 10.7265 5.82618C10.7072 6.09767 10.4843 6.31612 10.2042 6.32286C9.90172 6.33005 9.59877 6.32511 9.29582 6.32511C8.51642 6.32511 7.73702 6.32511 6.95807 6.32511V6.32556Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_15632_14487", children: /* @__PURE__ */ C(
        "rect",
        {
          fill: "currentColor",
          height: "14",
          transform: "translate(0.5)",
          width: "12.9217"
        }
      ) }) })
    ]
  }
);
export {
  e as Content
};
